import { Form, Input, Typography } from "antd";
import { Stethoscope } from "lucide-react";

const { Title } = Typography;

export default function StepSymptoms({ formData, onChangeField, errors = {} }) {
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Stethoscope className="w-6 h-6 text-[#0B7BC1]" />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          Present Symptoms
        </Title>
      </div>

      <Form.Item
        label={
          <>
            Chief Complaint <span className="text-red-500">*</span>
          </>
        }
        required
        validateStatus={errors.chiefComplaint ? "error" : ""}
        help={errors.chiefComplaint}
      >
        <Input
          placeholder="Enter chief complaint"
          value={formData.chiefComplaint}
          onChange={(e) => onChangeField("chiefComplaint", e.target.value)}
        />
      </Form.Item>

      <Form.Item label="Symptoms Description">
        <Input.TextArea
          placeholder="Describe symptoms in detail"
          value={formData.symptomsDescription}
          onChange={(e) => onChangeField("symptomsDescription", e.target.value)}
          autoSize={{ minRows: 4 }}
        />
      </Form.Item>

      <Form.Item label="HPI & Additional Notes">
        <Input.TextArea
          placeholder="History of present illness, context, and additional information"
          value={formData.hpiNotes}
          onChange={(e) => onChangeField("hpiNotes", e.target.value)}
          autoSize={{ minRows: 4 }}
        />
      </Form.Item>
    </div>
  );
}

